<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useCustomerTaskCommentsFilters } from '../../model/task-comments/customer-task-comments-filters.hook'

defineOptions({
  name: 'CustomerTaskCommentsFilters',
})

const {
  filterResetKey,
  createdRange,
  disciplineOptions,
  disciplineInitialValue,
  handleDisciplineSelected,
  teamOptions,
  teamInitialValue,
  handleTeamSelected,
  taskTypeOptions,
  taskTypeInitialValue,
  handleTaskTypeSelected,
  handleSearch,
  handleClear,
} = useCustomerTaskCommentsFilters()
</script>

<template>
  <FiltersBar
    class="customer-task-comments-filters"
    @click:submit="handleSearch"
    @click:clear="handleClear"
  >
    <template #fields>
      <div
        :key="filterResetKey"
        class="customer-task-comments-filters__general"
      >
        <MultiSelectSearchable
          :key="`discipline-${disciplineOptions.length}`"
          class="multiselect-discipline"
          label="Disciplines"
          placeholder="Select here"
          :options="disciplineOptions"
          :value="disciplineInitialValue"
          :is-all-available="true"
          @selected="handleDisciplineSelected"
        />
        <MultiSelectSearchable
          :key="`team-${teamOptions.length}`"
          class="multiselect-team"
          label="Team"
          placeholder="Select here"
          :options="teamOptions"
          :value="teamInitialValue"
          :is-all-available="true"
          @selected="handleTeamSelected"
        />
        <MultiSelectSearchable
          :key="`task-type-${taskTypeOptions.length}`"
          class="multiselect-task-type"
          label="Task Type"
          placeholder="Select here"
          :options="taskTypeOptions"
          :value="taskTypeInitialValue"
          :is-all-available="true"
          @selected="handleTaskTypeSelected"
        />
        <FilterDateRange
          v-model="createdRange"
          class="customer-task-comments-filters__date"
          label="Creation date"
          placeholder="Select date"
        />
      </div>
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./CustomerTaskCommentsFilters.scss" />